import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitter } from '@angular/core';

// Import global data service
import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabindingService } from 'src/app/Services/Databinding/databinding.service';
import { APP_BASE_LINK } from 'src/environments/constants';

@Component({
  selector: 'app-bulk-invite-template',
  templateUrl: './bulk-invite-template.component.html',
  styleUrls: ['./bulk-invite-template.component.css']
})
export class BulkInviteTemplateComponent implements OnInit {
  options: any = {
    header: 'SignNow',
    color: '#5cb85c', // red, blue....
    widthProsentage: 25, // The with of the popou measured by browser width
    animationDuration: 1, // in seconds, 0 = no animation
    showButtons: true, // You can hide this in case you want to use custom buttons
    confirmBtnContent: 'OK', // The text on your confirm button
    cancleBtnContent: 'Cancel', // the text on your cancel button
    confirmBtnClass: '', // your class for styling the confirm button
    cancleBtnClass: '', // you class for styling the cancel button
    animation: 'fadeInDown' // 'fadeInLeft', 'fadeInRight', 'fadeInUp', 'bounceIn','bounceInDown'
  };
  // instantiate templates to an empty array
  folders: any = [];
  templates: any = [];
  templates_folder: any = [];
  title: string = 'templates';
  type: string = '';
  state: string = 'inactive';
  selected_document: any;
  new_document: any;
  selected_document_name: string = '';
  new_document_group_name: string = '';
  // user login
  login: boolean = false;
  user_data: any;
  // Document Group Variables
  document_group_count: number = 0;
  okay_to_generate_document_group: boolean = false;

  // Loading
  loading: Loading;

  // error
  error_messages: any = [];

  // Popups
  document_popup: boolean = false;
  group_popup: boolean = false;
  is_show_pushback_popup: boolean = false;

  // pushback
  selected_pushback_document: any;
  is_user_owner_of_selected_document: boolean = true;
  pushback_type: any = { name: '' }; // it can be changed by reference in databinding-form
  display_pushback: boolean;

  // Edit document
  edit_document_url: any;
  edit_document: boolean = false;

  // template_settings
  template_setting: any;
  template_setting_id: string;
  using_template_settings: boolean;
  loading_template_setting: boolean;

  // Data
  data: any = [];
  salesforce: any = [];
  record_list: any = [];
  bulk_invite_type: string;
  selectedObjectType: string;
  // pre-selected template
  selected_template_id: string;

  salesforce_session_data: any;

  // email dropdown
  emails: any = [];

  // refresh the page
  refresh: boolean;

  //
  type_placeholder: string = 'SALESFORCE_RECORD_TYPE';
  /**
   * @ouput onDocumentSelected - outputs the current
   *          document whenever a new document is selected
   */
  onDocumentSelected: EventEmitter<any>;
  sfObjectsList = [];
  sfCurrObjMetaList = [];
  pushBackErrorsMsg = {
    cannotAddPushbackToRecord: `Cannot save Data Binding without a specified 'Salesforce Record Type'. Please update Data Binding.`,
    cannotAssignPushbackRecord: `Cannot save Data Binding without at least one specified 'Salesforce Field Name'. Please update Data Binding.`,
    duplicatePushbackField:
      'Duplicate field values detected for Salesforce Data Binding. Please ensure all field values for updating a record are unique.',
    duplicatePushbackTypes:
      'Duplicate Salesforce Type values. Please make sure that there is only one Type value for Data Binding.'
  };

  appendingDataErrorMsg = {
    general_error: 'Error prefilling data into signnow fields from salesforce.'
  };
  constructor(
    private router: Router,
    private dataService: DataService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private databindingService: DatabindingService
  ) {
    this.loading = dataService.getLoading();
    this.onDocumentSelected = new EventEmitter();
    renderer.listen('window', 'message', this.handleMessage.bind(this));
  }

  handleMessage(event: Event) {
    const message = event as MessageEvent;
    if (message.data === 'close_popup') {
      this.edit_document = false;
      this.edit_document_url = '';
      this.reload_view();
    }
  }

  loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
    this.record_list = this.dataService.getRecordList();
    this.bulk_invite_type = this.dataService.getUrlParamater('bulk_invite_type');
  }

  checkData() {
    try {
      this.dataService.loadSalesforceData();
      const SF_Data = this.dataService.getSalesforceData();
      this.type_placeholder = 'SALESFORCE_RECORD_TYPE (' + SF_Data.record_type + ')';
      this.sfObjectsList.push(SF_Data.record_type);
      this.bulk_invite_type = this.dataService.getUrlParamater('bulk_invite_type');
      if (this.bulk_invite_type) {
        this.sfObjectsList.push(this.bulk_invite_type + '_bulk');
      }

      // send information to db: user will be added if not already found in db otherwise user data will be updated
      this.user_data = {
        sf_user_id: SF_Data.sf_user_id,
        sn_token: '',
        sn_refresh: '',
        sf_org_id: SF_Data.sf_org_id,
        sf_token: SF_Data.sf_token,
        sf_refresh: SF_Data.sf_refresh,
        instance_url: SF_Data.instance_url
      };
      this.updateLoading(true, "Checking validity of user's token.");

      this.dataService
        .apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + SF_Data.sf_user_id)

        .subscribe((result) => {
          if (!(result.in_db == true && result.valid_sn_token == true)) {
            this.updateLoading(false, '');
            this.folders = [];
            this.login = true; // this variable makes the login div visiable
            return;
          } else {
            //////////////////////////// user data has all the information needed to connect to signnow ///////////////////////////////

            var sn_token = result.sn_token;
            var sn_refresh = result.sn_refresh;
            this.user_data.sn_token = sn_token;
            this.user_data.sn_refresh = sn_refresh;
            this.dataService.setSignNowOwnerEmail(result.sn_email);
            this.DataIsValid();
            //////////////////////////////// update user db /////////////////////////////////////////////////////////////////////////////
            if (this.user_data.sn_token != '') {
              this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
            }
          }
        });
    } catch (error) {
      return error;
    }
  }
  setOriginView(view: string, page_view: string) {
    if (page_view == undefined) {
      this.dataService.setOriginView(view);
    } else {
      this.dataService.setOriginView(page_view);
    }
  }

  loadPages() {
    this.updateLoading(true, '');
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
  }

  DataIsValid() {
    var template_setting_id = this.dataService.getUrlParamater('template_setting');

    if (template_setting_id != '' && template_setting_id.length > 0) {
      this.using_template_settings = true;
      this.loading_template_setting = true;
      this.loadTemplateSettingAndPages(template_setting_id);
    } else {
      this.using_template_settings = false;
      this.loadPages();
    }
  }

  redirect_to_status_view() {
    this.router.navigate(['status']);
  }
  //this function recives the information from the parent frame and creates a user data object that is returned
  async generate_user_data_object() {
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    var sf_token = this.salesforce_session_data.sf_token;
    var sf_refresh = this.salesforce_session_data.sf_refresh;
    var sf_org_id = this.salesforce_session_data.sf_org_id;
    var sf_user_id = this.salesforce_session_data.sf_user_id;
    var instance_url = this.salesforce_session_data.instance_url;

    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      this.folders = [];
      this.login = true;
      return;
    }
    var user_data = {
      sf_user_id: sf_user_id,
      sn_token: '',
      sn_refresh: '',
      sf_org_id: sf_org_id,
      sf_token: sf_token,
      sf_refresh: sf_refresh,
      instance_url: instance_url
    };
    return user_data;
  }

  async ngOnInit() {
    this.refresh = false;
    this.loadSalesforceDataIntoDataService();
    // check what view to use

    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      this.folders = [];
      this.login = true;
      return;
    }
    var view = this.salesforce_session_data.view;
    var page_view = this.dataService.getUrlParamater('view').toLowerCase();
    this.bulk_invite_type = this.dataService.getUrlParamater('bulk_record_type');

    this.setOriginView(view, page_view);
    this.checkData();
  }

  loadTemplateSetting(template_setting_id) {
    this.updateLoading(true, 'Loading template settings data.');
    this.loadInfo();
    var ignore_type = this.bulk_invite_type;
    var data = {
      sf_token: this.salesforce.sf_token,
      instance_url: this.salesforce.instance_url,
      template_setting_id: template_setting_id,
      record_id: this.salesforce.record_id,
      ignore_type: ignore_type
    };
    this.dataService
      .apiPostCall('/api/get_template_setting_ignore', data)

      .subscribe(
        (result) => {
          this.dataService.setTemplateSetting(result);
          this.template_setting = result;
          this.loading_template_setting = false;
          this.loadInfo();
          this.updateLoading(false, '');
        },
        (error) => {
          if (error.status == 504) {
            this.updateError('Failed to load Template Setting.');
          } else {
            this.updateError(error.error);
          }

          this.using_template_settings = false;
          this.loading_template_setting = false;
          this.loadPages();
          this.updateLoading(false, '');
        }
      );
  }
  loadTemplateSettingAndPages(template_setting_id) {
    this.updateLoading(true, 'Loading template settings data.');
    this.loadInfo();
    var ignore_type = this.bulk_invite_type;
    var data = {
      sf_token: this.salesforce.sf_token,
      instance_url: this.salesforce.instance_url,
      template_setting_id: template_setting_id,
      record_id: this.salesforce.record_id,
      ignore_type: ignore_type
    };
    this.dataService
      .apiPostCall('/api/get_template_setting_ignore', data)

      .subscribe(
        (result) => {
          this.dataService.setTemplateSetting(result);
          this.template_setting = result;
          this.loading_template_setting = false;
          this.loadPages();
        },
        (error) => {
          this.updateError(error.error);
          this.using_template_settings = false;
          this.loading_template_setting = false;
          this.loadPages();
          this.updateLoading(false, '');
        }
      );
  }
  removeErrorMessage(error_message) {
    for (var i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        //delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  async loadSalesforceDataIntoDataService() {
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    var sf_token = this.salesforce_session_data.sf_token;
    var sf_refresh = this.salesforce_session_data.sf_refresh;
    var sf_org_id = this.salesforce_session_data.sf_org_id;
    var sf_user_id = this.salesforce_session_data.sf_user_id;
    var instance_url = this.salesforce_session_data.instance_url;
    var record_type = this.salesforce_session_data.record_type;
    var record_id = this.salesforce_session_data.record_id;
    var context = this.salesforce_session_data.context;

    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      this.folders = [];
      this.login = true;
      return;
    }
    // set information in data service
    this.dataService.setSalesforceRefresh(sf_refresh);
    this.dataService.setSalesforceToken(sf_token);
    this.dataService.setSalesforceOrgId(sf_org_id);
    this.dataService.setSalesforceUserId(sf_user_id);
    this.dataService.setSalesforceInstanceUrl(instance_url);
    this.dataService.setSalesforceRecordType(record_type);
    this.dataService.setSalesforceRecordId(record_id);
    this.dataService.setSalesforceContext(context);
    this.getRecordEmails(record_type, instance_url, sf_token);
  }

  getRecordEmails(record_type, instance_url, sf_token) {
    var data = {
      sf_token: sf_token,
      instance_url: instance_url,
      record_type: record_type
    };
    this.dataService
      .apiPostCall('/api/get_emails', data)

      .subscribe((result) => {
        try {
          var res: any = JSON.parse(result);
          this.dataService.setRecordEmails(res);
        } catch {}
      });
  }

  async loadSalesforceDataFromParentFrameAndUpdateUserDB() {
    try {
      this.salesforce_session_data = await this.dataService
        .apiGetCall('/api/salesforce_session_data')
        .toPromise();

      this.dataService.maintenanceCheck(this.salesforce_session_data);

      var sf_token = this.salesforce_session_data.sf_token;
      var sf_refresh = this.salesforce_session_data.sf_refresh;
      var sf_org_id = this.salesforce_session_data.sf_org_id;
      var sf_user_id = this.salesforce_session_data.sf_user_id;
      var instance_url = this.salesforce_session_data.instance_url;

      if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
        this.updateLoading(false, '');
        this.updateError(this.dataService.salesforce_session_error);
        this.folders = [];
        this.login = true;
        return;
      }

      // send information to db: user will be added if not already found in db otherwise user data will be updated
      this.user_data = {
        sf_user_id: sf_user_id,
        sn_token: '',
        sn_refresh: '',
        sf_org_id: sf_org_id,
        sf_token: sf_token,
        sf_refresh: sf_refresh,
        instance_url: instance_url
      };
      this.updateLoading(true, 'Loading SignNow data');

      this.dataService
        .apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id)

        .subscribe((result) => {
          //

          if (!(result.in_db == true && result.valid_sn_token == true)) {
            //
            // login before continuing

            this.updateLoading(false, '');
            this.folders = [];
            this.login = true; // this variable makes the login div visiable
            return;
          } else {
            var sn_token = result.sn_token;
            var sn_refresh = result.sn_refresh;
            this.user_data.sn_token = sn_token;
            this.user_data.sn_refresh = sn_refresh;
            this.dataService.setSignNowOwnerEmail(result.sn_email);
            this.getAllFoldersAndDocuments();
            if (this.user_data.sn_token != '') {
              this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
            }
          }
        });
    } catch (error) {
      return error;
    }
  }

  reload() {
    this.loadSalesforceDataIntoDataService();
  }

  valid_value(value): boolean {
    if (!value || typeof value === 'undefined') {
      return false;
    }
    return true;
  }

  hideAllModals() {
    this.document_popup = false;
    this.group_popup = false;
    this.is_show_pushback_popup = false;
  }

  toggleMove() {
    this.state = this.state === 'inactive' ? 'active' : 'inactive';
  }
  documentNamePopup(document: any) {
    this.document_popup = true;
    this.group_popup = false;
    this.selected_document = document;
    if (this.using_template_settings == true) {
      if (this.template_setting.document_name.length == 0) {
        this.selected_document_name = document.document_name;
      } else if (this.template_setting.document_name.split(' ').join('') === '') {
        this.selected_document_name = document.document_name;
      } else if (
        this.template_setting.document_name !== undefined ||
        this.template_setting.document_name !== null
      ) {
        this.selected_document_name = this.template_setting.document_name;
      } else {
        this.selected_document_name = document.document_name;
      }
      if (this.template_setting.skip_to_email_invite) {
        this.cloneTemplate(this.selected_document_name);
      }
    } else {
      this.selected_document_name = document.document_name;
    }
  }
  documentGroupNamePopup() {
    this.group_popup = true;
    this.document_popup = false;
    this.new_document_group_name = 'Document Group';
    if (this.using_template_settings == true) {
      if (this.template_setting.document_name.split(' ').join('') === '') {
        this.new_document_group_name = 'Document Group';
      } else if (
        this.template_setting.document_name !== undefined ||
        this.template_setting.document_name !== null
      ) {
        this.new_document_group_name = this.template_setting.document_name;
      } else {
        this.new_document_group_name = 'Document Group';
      }
      if (this.template_setting.skip_to_email_invite) {
        this.generateDocumentGroup(this.new_document_group_name);
      }
    }
  }
  generateDocumentGroup(new_group_name: string): void {
    this.updateLoading(true, 'Generating new document group from the selected SignNow templates.');

    if (new_group_name.split(' ').join('') == '') {
      this.okay_to_generate_document_group = false;
      this.dataService.clearDocumentGroup();
      this.updateLoading(false, '');
      this.updateError("Document group name can't be empty.");
      this.reset_data_but_keep_origin_view_and_record_list();
      this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
      this.group_popup = false;
      this.document_popup = false;
      return;
    }

    // hide document group input popup
    this.group_popup = false;
    // update data service with new document group name
    this.dataService.setGroupName(new_group_name);
    // clone templates list to documents
    var document_group_data = this.dataService.getDocumentGroup();

    this.dataService
      .apiPostCall('/api/clone_template_list', JSON.stringify(document_group_data.template_ids))

      .subscribe(
        (result) => {
          this.updateLoading(true, 'Documents in group cloned');
          var document_ids = result;
          this.dataService.setDocumentGroupDocIds(document_ids);
          // generate document group

          this.dataService
            .apiPostCall(
              '/api/generate_document_group?document_group_name=' + new_group_name,
              JSON.stringify(document_ids)
            )

            .subscribe((result) => {
              this.updateLoading(true, 'Document group successfully generated.');
              var document_group_id = result.id;
              this.dataService.setDocumentGroupId(document_group_id);
              this.setDocumentGroupDataAndAddAnnotations(document_group_id, document_ids);
            });
        },
        (error) => {
          this.okay_to_generate_document_group = false;
          this.dataService.clearDocumentGroup();
          this.updateLoading(false, '');
          this.updateError(error.error);
          this.reset_data_but_keep_origin_view_and_record_list();
          this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
        }
      );
  }

  setDocumentGroupDataAndAddAnnotations(document_group_id: string, document_ids) {
    this.updateLoading(true, 'Getting document group data for adding annotations.');

    this.dataService
      .apiGetCall('/api/get_document_group_data?group_id=' + document_group_id)

      .subscribe((result) => {
        this.dataService.setDocumentGroupData(result);
        // load annoations into document group data service
        var document_count = document_ids.length;
        var count = 0;
        this.updateLoading(true, 'Getting document group annotations.');
        for (var i = 0; i < document_ids.length; i++) {
          this.dataService
            .apiGetCall('/api/get_document_annotations?document_id=' + document_ids[i])

            .subscribe((result) => {
              var res: any = result;
              var salesforce_annotations: any = res.integration_objects;

              count++;
              if (salesforce_annotations != null) {
                this.dataService.addDocumentAnnotationInDocumentGroup({
                  document_annotation: salesforce_annotations
                });
              }

              if (document_count == count) {
                // add annotations to each document
                this.addAnnotationsToDocumentsInGroup();
              }
            });
        }
      });
  }

  addAnnotationsToDocumentsInGroup() {
    this.updateLoading(true, 'Adding annotations to documents in the document group.');
    var document_group = this.dataService.getDocumentGroup();
    var document_count = document_group.documents.length;
    var salesforce_data = this.dataService.getSalesforceData();
    var count = 0;
    for (
      var i = 0;
      i < document_group.annotations.length && this.okay_to_generate_document_group == true;
      i++
    ) {
      var salesforce_annotation_data = {
        sf_token: salesforce_data.sf_token,
        instance_url: salesforce_data.instance_url,
        record_type: salesforce_data.record_type,
        record_id: salesforce_data.record_id,
        annotations: document_group.annotations[i].document_annotation
      };
      if (document_group.annotations[i].document_annotation.length != 0) {
        this.dataService
          .apiPostCall(
            '/api/add_annotations_to_document?document_id=' +
              document_group.annotations[i].document_annotation[0].document_id,
            salesforce_annotation_data
          )

          .subscribe(
            (result) => {
              var res: any = JSON.parse(result);
              if (res.success == true && this.okay_to_generate_document_group == true) {
                count++;
                if (document_count == count) {
                  this.dataService.documentGroupMode(true);
                  this.updateLoading(
                    true,
                    'Annotations successfully added to documents  in the document group.'
                  );
                  this.loading.hide();
                  //
                  this.router.navigate(['send'], { queryParams: { sending_type: 'bulk_invite' } }).then(
                    function () {},
                    function () {}
                  );
                } else if (res.success == false) {
                  this.okay_to_generate_document_group = false;
                  this.dataService.clearDocumentGroup();
                  this.updateLoading(false, '');
                  this.updateError(res.error);
                  this.reset_data_but_keep_origin_view_and_record_list();
                  this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
                }
              }
            },
            () => {
              this.updateError(
                'An error has occured while processing Salesforce annotations. Please make sure that there are no empty Salesforce field values for the annotations.'
              );
              this.updateLoading(false, '');
              return;
            }
          );
      } else {
        count++;
        if (document_count == count) {
          this.dataService.documentGroupMode(true);
          this.updateLoading(true, 'Annotations successfully added to documents  in the document group.');

          this.router.navigate(['send'], { queryParams: { sending_type: 'bulk_invite' } }).then(
            function () {},
            function () {}
          );
        }
      }
    }
  }
  addAnnotationsToDocumentWithIgnoreType(ignore_type: string) {
    var salesforce = this.dataService.getSalesforceData();
    var data = this.dataService.getData();
    var salesforce_annotation_data = {
      sf_token: salesforce.sf_token,
      instance_url: salesforce.instance_url,
      record_type: salesforce.record_type,
      record_id: salesforce.record_id,
      ignore_type: ignore_type
    };
    this.updateLoading(true, 'Adding annotations data from salesforce to the document.');
    this.dataService
      .apiPostCall(
        '/api/add_annotations_to_document_with_ignore_type?document_id=' + data.document_id,
        salesforce_annotation_data
      )

      .subscribe(
        (result) => {
          var res: any = JSON.parse(result);
          if (res.success == true) {
            this.loading.hide();
            this.router.navigate(['send'], { queryParams: { sending_type: 'bulk_invite' } });
          } else {
            this.updateLoading(false, '');
            this.updateError(res.error);
            this.reset_data_but_keep_origin_view_and_record_list();
            this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
          }
        },
        () => {
          this.updateLoading(false, '');
          this.updateError(
            'An error has occured while processing Salesforce annotations. Please make sure that there are no empty Salesforce field values for the annotations.'
          );
        }
      );
  }
  clearErrors() {
    this.error_messages = [];
  }
  updateLoadingEvent($event) {
    this.updateLoading($event.state, $event.msg);
  }
  updateLoading(state: boolean, msg: string) {
    if (this.using_template_settings == true && this.loading_template_setting == true) {
      this.loading.update(true, msg);
    } else {
      this.loading.update(state, msg);
    }
  }

  preselectedTemplate(selected_template_id) {
    this.updateLoading(true, 'Loading preselected template.');

    this.dataService
      .apiGetCall('/api/get_document?document_id=' + selected_template_id)

      .subscribe((result) => {
        var template = result;
        this.updateLoading(false, '');
        this.documentNamePopup(template);
      });
  }

  reload_view() {
    this.refresh = false;
    this.updateLoading(false, '');
    this.reset_data_but_keep_origin_view_and_record_list();
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    this.hideAllModals();
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  prep_document_for_databinding(document) {
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackTypes);
    var data_binding_types: Set<string> = new Set<string>();
    for (var i = 0; i < document.fields.length; i++) {
      if (
        document.fields[i].json_attributes.name == null ||
        document.fields[i].json_attributes.name == undefined
      ) {
        document.fields[i].json_attributes.name = '';
      }

      if (
        document.fields[i].json_attributes.label == null ||
        document.fields[i].json_attributes.label == undefined
      ) {
        document.fields[i].json_attributes.label = '';
      }
      var integrations;
      if (
        document.fields[i].json_attributes.integrations == undefined ||
        document.fields[i].json_attributes.integrations == null
      ) {
        integrations = [
          {
            type: '',
            field: '',
            update: 'no',
            isAppendToSN: 'no',
            integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
          }
        ];
      } else {
        integrations = document.fields[i].json_attributes.integrations;
        if (
          integrations[0].type != '' &&
          this.databindingService.isAllowedTypeOfDocumentField(document.fields[i].type)
        ) {
          data_binding_types.add(integrations[0].type);
        }
      }
      document.fields[i].integrations = integrations;
    }
    var data_binding_types_arr = Array.from(data_binding_types);
    if (data_binding_types_arr.length > 1) {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.duplicatePushbackTypes, true);
      return document;
    } else {
      this.pushback_type.name = data_binding_types_arr[0] != undefined ? data_binding_types_arr[0] : '';
    }
    return document;
  }

  async AppendSFDataToPrefillSNFields(document) {
    this.clearErrors();
    this.updateLoading(true, 'Adding Salesforce Fields to the Document.');
    var new_document = this.prep_document_for_databinding(document);
    var fields = [];
    var field_value_counts = new Map<string, number>();
    var field_value_counts_update = new Map<string, number>();
    var valid_field_count = 0;
    for (let i = 0; i < new_document.fields.length; i++) {
      var value = new_document.fields[i].integrations[0].field;

      if (value !== '' && this.databindingService.isAllowedTypeOfDocumentField(new_document.fields[i].type)) {
        valid_field_count++;
        var count: number = field_value_counts.get(value) == undefined ? 0 : field_value_counts.get(value);
        count++;
        field_value_counts.set(value, count);

        if (new_document.fields[i].isUpdateSfFieldFromDocument === true) {
          const update_count: number =
            field_value_counts_update.get(value) == undefined ? 1 : field_value_counts_update.get(value) + 1;
          field_value_counts_update.set(value, update_count);
        }
      }
    }

    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackField);

    if (valid_field_count > 0 && this.pushback_type.name.split(' ').join('') === '') {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAddPushbackToRecord, true);
      return;
    }
    if (valid_field_count == 0 && this.pushback_type.name !== '') {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAssignPushbackRecord, true);
      return;
    }
    for (let entry of Array.from(field_value_counts_update.entries())) {
      let count = entry[1];
      if (count > 1) {
        this.resetDataAndUpdateError(this.pushBackErrorsMsg.duplicatePushbackField, true);
        return;
      }
    }

    const salesforce_data = this.dataService.getSalesforceData();
    const params = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      sf_obg_type: this.pushback_type.name,
      sf_obg_id: salesforce_data.record_id
    };
    var record: any;
    try {
      var record = await this.dataService
        .apiGetCall('/api/get_record_by_id', { params })

        .toPromise();
      if (record) {
        for (let i = 0; i < new_document.fields.length; i++) {
          if (this.databindingService.isAllowedTypeOfDocumentField(new_document.fields[i].type)) {
            new_document.fields[i].integrations[0].type = this.pushback_type.name;
          }

          var prefilledValueFromForm = new_document.fields[i].integrations[0].field;
          var previousPrefilledValue = new_document.fields[i].json_attributes.prefilled_text;
          var prefilledValueFromRecord = record[prefilledValueFromForm] || previousPrefilledValue;

          var type = new_document.fields[i].integrations[0].type;
          var finalPrefill = new_document.fields[i].json_attributes.prefilled_text;
          if (
            type.substring(type.length - 5, type.length) == '_bulk' &&
            new_document.fields[i].integrations[0].isAppendToSN
          ) {
            finalPrefill = new_document.fields[i].json_attributes.prefilled_text;
          } else {
            finalPrefill =
              new_document.fields[i].integrations[0].isAppendToSN === 'yes'
                ? prefilledValueFromRecord
                : previousPrefilledValue;
          }
          const field: any = this.databindingService.initDefaultFieldForPushback(
            new_document,
            new_document.fields[i]
          );
          field.prefilled_text = finalPrefill;

          field.integrations.push(new_document.fields[i].integrations[0]);
          fields.push(field);
        }

        this.setDatabindingInfoForAnalytics(fields); // only when updating the document that will be sent to Send Page

        try {
          await this.dataService
            .apiPostCall(
              '/api/add_pushback_to_template',
              JSON.stringify({
                document_id: new_document.id,
                pushback_fields: fields
              })
            )

            .toPromise();
          return true;
        } catch {
          return false;
        }
      } else if (record && record.errorCode) {
        console.log(record.errorCode);
        return false;
      }
    } catch (error) {
      //
      this.updateLoading(false, '');
      this.updateError(error.error);
      return false;
    }
  }

  // todo move to Databinding Service
  // for analytics purpose
  // only when updating the document that will be sent to Send Page
  setDatabindingInfoForAnalytics(fields) {
    const databindingInfoForAnalytics = {
      is_update: fields.some((field) => field.integrations[0].update === 'yes'),
      is_append: fields.some((field) => field.integrations[0].isAppendToSN === 'yes')
    };
    this.dataService.addAnalyticsDatabindingInfo(databindingInfoForAnalytics);
  }

  addPushbackDataToDocument() {
    this.clearErrors();
    this.updateLoading(true, 'Adding pushback data to the template.');
    // alert("adding pushback data to document " + this.selected_pushback_document.document_name);
    var fields = [];
    var field_value_counts = new Map<string, number>();
    var field_value_counts_update = new Map<string, number>();
    var valid_field_count = 0;
    for (let i = 0; i < this.selected_pushback_document.fields.length; i++) {
      var value = this.selected_pushback_document.fields[i].integrations[0].field;

      if (
        value !== '' &&
        this.databindingService.isAllowedTypeOfDocumentField(this.selected_pushback_document.fields[i].type)
      ) {
        valid_field_count++;
        var count: number = field_value_counts.get(value) == undefined ? 0 : field_value_counts.get(value);
        count++;
        field_value_counts.set(value, count);

        if (this.selected_pushback_document.fields[i].isUpdateSfFieldFromDocument === true) {
          const update_count: number =
            field_value_counts_update.get(value) == undefined ? 1 : field_value_counts_update.get(value) + 1;
          field_value_counts_update.set(value, update_count);
        }
      }
    }

    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAddPushbackToRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.cannotAssignPushbackRecord);
    this.removeErrorMessage(this.pushBackErrorsMsg.duplicatePushbackField);

    if (valid_field_count > 0 && this.pushback_type.name.split(' ').join('') == '') {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAddPushbackToRecord, true);
      return;
    }
    if (valid_field_count == 0 && this.pushback_type.name != '') {
      this.resetDataAndUpdateError(this.pushBackErrorsMsg.cannotAssignPushbackRecord, true);
      return;
    }
    for (let entry of Array.from(field_value_counts_update.entries())) {
      let count = entry[1];
      if (count > 1) {
        this.resetDataAndUpdateError(this.pushBackErrorsMsg.duplicatePushbackField, true);
        return;
      }
    }

    for (let i = 0; i < this.selected_pushback_document.fields.length; i++) {
      if (
        this.databindingService.isAllowedTypeOfDocumentField(this.selected_pushback_document.fields[i].type)
      ) {
        this.selected_pushback_document.fields[i].integrations[0].type = this.pushback_type.name;
      }

      const field: any = this.databindingService.initDefaultFieldForPushback(
        this.selected_document,
        this.selected_pushback_document.fields[i]
      );

      const prefilledValueFromForm = this.selected_pushback_document.fields[i].integrations[0].field;
      this.selected_pushback_document.fields[i].integrations[0].update =
        prefilledValueFromForm && this.selected_pushback_document.fields[i].isUpdateSfFieldFromDocument
          ? 'yes'
          : 'no';
      this.selected_pushback_document.fields[i].integrations[0].isAppendToSN =
        prefilledValueFromForm && this.selected_pushback_document.fields[i].isAppendSfFieldIntoSnField
          ? 'yes'
          : 'no';

      if (
        this.selected_pushback_document.fields[i].integrations[0].update === 'no' &&
        this.selected_pushback_document.fields[i].integrations[0].isAppendToSN === 'no'
      ) {
        this.selected_pushback_document.fields[i].integrations[0].field = '';
      }

      field.integrations.push(this.selected_pushback_document.fields[i].integrations[0]);
      fields.push(field);
    }

    this.dataService
      .apiPostCall(
        '/api/add_pushback_to_template',
        JSON.stringify({
          document_id: this.selected_pushback_document.id,
          pushback_fields: fields
        })
      )

      .subscribe(() => {
        this.reset_data_but_keep_origin_view_and_record_list();
        this.updateLoading(true, 'Reloading data.');
        this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
        this.hideAllModals();
      });
  }

  reset_data_but_keep_origin_view_and_record_list() {
    var origin_view = this.dataService.getOriginView();
    var record_list = this.dataService.getRecordList();
    this.dataService.resetData();
    this.dataService.setOriginView(origin_view);
    this.dataService.setRecordList(record_list);
  }

  search_templates(value) {
    // Declare variables
    var input, filter, table, tr, td, i;
    input = value;
    filter = input.toUpperCase();
    table = document.getElementById('TemplateTable');
    tr = table.getElementsByTagName('tr');

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName('td')[0];
      if (td) {
        if (td.innerText.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = '';
        } else {
          tr[i].style.display = 'none';
        }
      }
    }
  }

  documentSettings(selected_option, document) {
    this.clearErrors();
    if (this.refresh == true && selected_option.value == 'pushback') {
      selected_option.selectedIndex = 0;
      this.updateError('Please click Reload before setting Data Binding for the document.');
      return;
    }

    var count_num_appropriate_fields_in_doc = 0;
    this.refresh = false;
    if (selected_option.value == 'edit') {
      var redirect_url = window.location.origin + '/close_popup';
      this.edit_document = true;

      var sn_token = this.user_data.sn_token;
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${APP_BASE_LINK}/webapp/document/${
          document.id
        }?access_token=${sn_token}&redirect_uri=${encodeURIComponent(redirect_url)}`
      );
      // this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(`${APP_BASE_LINK}/webapp/document/${document.id}?redirect_uri=${encodeURIComponent(redirect_url)}`);
      selected_option.selectedIndex = 0;
    } else if (selected_option.value === 'annotations') {
      var url = `${APP_BASE_LINK}/webapp/annotations/${document.id}?annotation_types=salesforce`;
      window.open(url, '_blank');
      selected_option.selectedIndex = 0;
    } else if (selected_option.value === 'pushback') {
      this.is_show_pushback_popup = true;
      for (var i = 0; i < document.fields.length; i++) {
        if (this.databindingService.isAllowedTypeOfDocumentField(document.fields[i].type)) {
          count_num_appropriate_fields_in_doc++;
        }
        if (
          document.fields[i].json_attributes.name == null ||
          document.fields[i].json_attributes.name == undefined
        ) {
          document.fields[i].json_attributes.name = '';
        }

        if (
          document.fields[i].json_attributes.label == null ||
          document.fields[i].json_attributes.label == undefined
        ) {
          document.fields[i].json_attributes.label = '';
        }
        var integrations;
        if (
          document.fields[i].json_attributes.integrations == undefined ||
          document.fields[i].json_attributes.integrations == null
        ) {
          integrations = [
            {
              type: '',
              field: '',
              update: 'no',
              isAppendToSN: 'no',
              integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
            }
          ];
        } else {
          integrations = document.fields[i].json_attributes.integrations;
        }
        document.fields[i].integrations = integrations;
      }
      if (count_num_appropriate_fields_in_doc == 0) {
        this.display_pushback = false;
      } else {
        this.display_pushback = true;
      }
      this.pushback_type.name = document.fields.length ? document.fields[0].integrations[0].type : '';
      this.selected_pushback_document = document;
      selected_option.selectedIndex = 0;

      this.is_user_owner_of_selected_document = this.selected_pushback_document.is_owner;
      // this.getSfObjectMeta(this.pushback_type.name);
    }
  }

  documentSettingsString(selected_option, document) {
    this.clearErrors();
    if (this.refresh == true && selected_option == 'pushback') {
      this.updateError('Please click Reload before setting Data Binding for the document.');
      return;
    }

    var count_num_appropriate_fields_in_doc = 0;
    this.refresh = false;
    if (selected_option == 'edit') {
      var redirect_url = window.location.origin + '/close_popup';
      this.edit_document = true;

      var sn_token = this.user_data.sn_token;
      this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${APP_BASE_LINK}/webapp/document/${
          document.id
        }?access_token=${sn_token}&redirect_uri=${encodeURIComponent(redirect_url)}`
      );
      //this.edit_document_url = this.sanitizer.bypassSecurityTrustResourceUrl(`${APP_BASE_LINK}/webapp/document/${document.id}?redirect_uri=${encodeURIComponent(redirect_url)}`);
    } else if (selected_option === 'annotations') {
      var url = `${APP_BASE_LINK}/webapp/annotations/${document.id}?annotation_types=salesforce`;
      window.open(url, '_blank');
    } else if (selected_option === 'pushback') {
      this.is_show_pushback_popup = true;
      for (var i = 0; i < document.fields.length; i++) {
        if (this.databindingService.isAllowedTypeOfDocumentField(document.fields[i].type)) {
          count_num_appropriate_fields_in_doc++;
        }
        if (
          document.fields[i].json_attributes.name == null ||
          document.fields[i].json_attributes.name == undefined
        ) {
          document.fields[i].json_attributes.name = '';
        }

        if (
          document.fields[i].json_attributes.label == null ||
          document.fields[i].json_attributes.label == undefined
        ) {
          document.fields[i].json_attributes.label = '';
        }
        var integrations;
        if (
          document.fields[i].json_attributes.integrations == undefined ||
          document.fields[i].json_attributes.integrations == null
        ) {
          integrations = [
            {
              type: '',
              field: '',
              update: 'no',
              isAppendToSN: 'no',
              integration_id: '98e94c607b2be81b9ddec0a8a2388066141b8027'
            }
          ];
        } else {
          integrations = document.fields[i].json_attributes.integrations;
        }
        document.fields[i].integrations = integrations;
      }
      if (count_num_appropriate_fields_in_doc == 0) {
        this.display_pushback = false;
      } else {
        this.display_pushback = true;
      }
      this.pushback_type.name = document.fields.length ? document.fields[0].integrations[0].type : '';
      this.selected_pushback_document = document;

      this.is_user_owner_of_selected_document = this.selected_pushback_document.is_owner;
      // this.getSfObjectMeta(this.pushback_type.name);
    }
  }

  cloneTemplate(new_name: any): void {
    this.updateLoading(true, 'Loading SignNow template.');
    this.document_popup = false;
    this.dataService.setDocumentName(new_name);
    this.dataService.setOriginTemplateId(this.selected_document.id);
    this.dataService.setDocumentOwner(this.selected_document.owner);

    if (new_name.split(' ').join('') == '') {
      this.updateLoading(false, '');
      this.updateError("Document name can't be empty.");
      this.reset_data_but_keep_origin_view_and_record_list();
      this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
      this.group_popup = false;
      this.document_popup = false;
      return;
    }

    var document: any = this.selected_document;
    var type = this.dataService.getSalesforceRecordType();
    var pushback_type = '';
    this.bulk_invite_type = this.dataService.getUrlParamater('bulk_invite_type');
    try {
      if (
        document.fields[0].json_attributes.integrations[0].type != null ||
        document.fields[0].json_attributes.integrations[0].type != undefined ||
        document.fields[0].json_attributes.integrations[0].type != ''
      ) {
        pushback_type = document.fields[0].json_attributes.integrations[0].type;
      }
    } catch {}

    if (
      pushback_type.toLowerCase() == '' ||
      pushback_type.toLowerCase() == (this.bulk_invite_type + '_bulk').toLowerCase() ||
      pushback_type.toLowerCase() == type.toLowerCase()
    ) {
      this.dataService
        .apiGetCall('/api/get_document?document_id=' + document.id)

        .subscribe((result) => {
          var document = result;
          if (document.roles.length == 0) {
            this.updateLoading(false, '');
            this.updateError(
              "Document doesn't have any Roles and Fields. Please add Roles and Fields to the Document before sending it out for signing."
            );
            this.reset_data_but_keep_origin_view_and_record_list();
            this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
          } else {
            this.dataService
              .apiGetCall(
                '/api/generate_document_from_template?template_id=' + document.id + '&new_name=' + new_name
              )

              .subscribe(
                (result) => {
                  this.updateLoading(
                    true,
                    'New document successfully generated. Making call to get document data.'
                  );
                  this.dataService.setDocumentId(result.id);

                  this.dataService
                    .apiGetCall('/api/get_document?document_id=' + result.id)

                    .subscribe(async (result) => {
                      var document = result;
                      if (document.roles.length == 0) {
                        this.updateLoading(false, '');
                        this.updateError(
                          "Document doesn't have any Roles and Fields. Please add Roles and Fields to the Document before sending it out for signing."
                        );
                        this.reset_data_but_keep_origin_view_and_record_list();
                        this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
                      } else if (document.routing_details.length == 0 && document.roles.length > 0) {
                        const routing = this.databindingService.createRoutingDetailsObject(document);

                        this.updateLoading(true, 'Updating document with Routing Details.');
                        this.dataService
                          .apiPostCall('/api/update_document_routing?document_id=' + document.id, routing)

                          .subscribe((result) => {
                            this.dataService
                              .apiGetCall('/api/get_document?document_id=' + result.document_id)

                              .subscribe(async (result) => {
                                this.new_document = result;
                                this.updateLoading(true, 'Document data received.');
                                // this.dataService.setRoutingDetails(this.new_document);  // now we do this on SEND page component with actual document fields data
                                //
                                var success = await this.AppendSFDataToPrefillSNFields(this.new_document);
                                //
                                if (success) {
                                  this.redirect_to_send_view();
                                }
                              });
                          });
                      } else if (document.roles.length != 0 && document.routing_details.length != 0) {
                        // this.dataService.apiGetCall("/api/get_document?document_id=" + result.id)
                        // .map(response => response.json())
                        // .subscribe(async result => {
                        // we already get document before
                        this.new_document = result;
                        this.updateLoading(true, 'Document data received.');
                        // this.dataService.setRoutingDetails(this.new_document.routing_details); // now we do this on send page with actual document fields data
                        var success = await this.AppendSFDataToPrefillSNFields(this.new_document);
                        if (success) {
                          this.redirect_to_send_view();
                        }
                        // });
                      }
                    });
                },
                (error) => {
                  this.updateError(error.error);
                  this.updateLoading(false, '');
                  return;
                }
              );
          }
        });
    } else {
      this.updateLoading(false, '');
      this.updateError(
        `For the template "${document.document_name}" Data Binding record type is set to "${pushback_type}". Go to Data Binding settings and choose "${type}" record type to send out this template.`
      ); //"Pushback Type is '" + pushback_type + "' but you're looking at a '" + type + "' record.
      this.reset_data_but_keep_origin_view_and_record_list();
      this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    }
  }

  redirect_to_send_view() {
    this.updateLoading(false, '');
    this.router.navigate(['send'], { queryParams: { sending_type: 'bulk_invite' } }).then(
      function () {},
      function () {}
    );
  }

  getDocumentsFromFolder(folder_id: string, callback) {
    this.dataService
      .apiGetCall('/api/templates_in_folder?folder_id=' + folder_id)

      .subscribe((result) => {
        callback(result);
      });
  }

  getAllFoldersAndDocuments() {
    const selected_template_id = this.dataService.getUrlParamater('template_id');
    const current_user_sn_email = this.dataService.getSignNowOwnerEmail();

    if (selected_template_id && selected_template_id.length > 0) {
      this.preselectedTemplate(selected_template_id);
    }
    this.updateLoading(true, 'Getting SignNow folders and documents.');

    this.dataService
      .apiGetCall('/api/folders')

      .subscribe(
        (result) => {
          for (let i = 0; i < result.folders.length; i++) {
            if (this.dataService.isAllowedFolder(result.folders[i].name)) {
              this.getDocumentsFromFolder(result.folders[i].id, (folder) => {
                folder.documents.forEach((docItem) => {
                  docItem.is_owner = docItem.owner === current_user_sn_email;

                  docItem.fields.forEach((fieldItem) => {
                    const jsonAttr = fieldItem.json_attributes;
                    if (jsonAttr.integrations && jsonAttr.integrations.length) {
                      fieldItem.isUpdateSfFieldFromDocument = jsonAttr.integrations[0]['update']
                        ? jsonAttr.integrations[0]['update'] === 'yes'
                        : false;
                      fieldItem.isAppendSfFieldIntoSnField = jsonAttr.integrations[0]['isAppendToSN']
                        ? jsonAttr.integrations[0]['isAppendToSN'] === 'yes'
                        : false;
                    }
                  });
                });

                this.folders = this.dataService.addFolderAndSort(this.folders, folder);
              });
            }
          }
          this.updateLoading(false, '');
        },
        (error) => {
          this.updateError(error.error);
          this.updateLoading(false, '');
          return;
        }
      );

    this.printToConsoleFolderData();
  }

  addToDocumentGroup(template, event) {
    var template_id = template.id;
    var type = this.dataService.getSalesforceRecordType();
    var pushback_type = '';
    try {
      if (
        template.fields[0].json_attributes.integrations[0].type != null ||
        template.fields[0].json_attributes.integrations[0].type != undefined ||
        template.fields[0].json_attributes.integrations[0].type != ''
      ) {
        pushback_type = template.fields[0].json_attributes.integrations[0].type;
      }
    } catch {}

    if (pushback_type != '' && pushback_type != type) {
      this.updateLoading(false, '');
      this.updateError(
        `For the template "${template.document_name}" Data Binding record type is set to "${pushback_type}". Go to Data Binding settings and choose "${type}" record type to send out this template.`
      );
      this.reset_data_but_keep_origin_view_and_record_list();
      this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
      return;
    }

    if (event.target.checked) {
      this.dataService.AddTemplateToDocumentGroup(template_id);
      this.document_group_count = this.dataService.getDocumentGroup().template_ids.length;
    } else {
      this.dataService.RemoveTemplateFromGroup(template_id);
      this.document_group_count = this.dataService.getDocumentGroup().template_ids.length;
    }

    if (this.document_group_count >= 2) {
      this.okay_to_generate_document_group = true;
    } else {
      this.okay_to_generate_document_group = false;
      //resets document group name
      this.dataService.setGroupName('');
      this.new_document_group_name = 'Document Group';
    }
  }

  printToConsoleFolderData() {
    for (var i = 0; i < this.folders.length; i++) {
      if (this.folders[i].name == 'Team Templates') {
        this.folders[i].name = this.folders[i].team_name;
      }
      for (var j = 0; j < this.folders[i].documents.length; j++) {}
    }
  }

  resetDataAndUpdateErrorEvent($event) {
    this.resetDataAndUpdateError(
      $event.errorMsg,
      $event.isHideModal,
      $event.updLoadingState,
      $event.updLoadingMsg
    );
  }
  resetDataAndUpdateError(errorMsg, isHideModal = false, updLoadingState = false, updLoadingMsg = '') {
    this.updateLoading(updLoadingState, updLoadingMsg);
    this.reset_data_but_keep_origin_view_and_record_list();
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    if (errorMsg !== false) {
      this.updateError(errorMsg);
    }
    if (isHideModal) {
      this.hideAllModals();
    }
  }

  bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
      element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + eventName, eventHandler);
    }
  }
}
